import React from 'react';
import { useIntl } from 'react-intl';

interface IAlertProps {
    message: string;
    type: string;
    translationId?: string;
}

const Alert = ({ message, type, translationId }: IAlertProps) => {
    const intl = useIntl();

    return (
        <div className="row row-m-b" style={{ padding: '0px 15px' }}>
            <div
                className={`col-md-12 alert alert-${type}`}
                style={{ margin: '20px 0px 0px 0px' }}
            >
                {translationId ? (
                    <strong
                        dangerouslySetInnerHTML={{
                            __html: intl.formatMessage({
                                id: translationId,
                                defaultMessage: message,
                            }),
                        }}
                    ></strong>
                ) : (
                    <strong>{message}</strong>
                )}
            </div>
        </div>
    );
};

export default Alert;
